module.exports = __webpack_public_path__ + "img/manage-vehicle.24cb0802.svg";